import { T_AppliedFilter } from '../state/filtersStore'
import { I_CasePost } from '../state/wpDataStore'

const extractAcfValue = (raw: any) =>
  raw && typeof raw === 'object' && 'value_new' in raw ? raw.value_new : raw

// weights: number = per-field weight; object = per-value overrides
const matchWeights: Record<
  string,
  number | { default?: number; [value: string]: number | undefined }
> = {
  //   building_type: { Factory: 8, default: 2 }, // Factory gets 8, other building_type matches get 2
  //   hvac_system_from: 5, // any match on this adds 5

  // * = Roger Hitchins notes

  // * The new system type of the case study matches one on the shortlist: 16
  // Dev note: RELATION_BONUS

  // * The original system type of the case study matches that entered by the user; 8
  hvac_system_from: 8,

  // * The level of changes to the building fabric or HVAC system of the case study matches the expected level of change entered by the user: 4
  fabric_system_changes: 4,

  // * The building type of the case study matches that entered by the user: 2
  building_type: 2,

  // * The floor area class of the case study matches that entered by the user : 1
  floor_area: 1,

  // Dev note: country not mentioned, but lets give match on country 1 point
  country: 1,
}

const getMatchWeight = (acf_name: string, matchedValue: unknown) => {
  const entry = matchWeights[acf_name]
  if (typeof entry === 'number') return entry
  if (entry && typeof entry === 'object') {
    const valKey = String(matchedValue)
    return entry[valKey] ?? entry.default ?? 1
  }
  return 1
}

const getRelatedSystemId = (casePost: I_CasePost) => {
  const rel = casePost.acf?.hvac_system_to as
    | { ID?: number; id?: number }
    | undefined
  return rel?.ID ?? rel?.id
}

const NO_SCORE_VALUES = ['other/unknown', 'unknown', 'other']

const RELATION_BONUS = 16

export const scoreCase = (
  casePost: I_CasePost,
  filters: T_AppliedFilter[],
  matchingSystemIds: Set<number> = new Set()
) => {
  const acf = casePost.acf ?? {}

  // Score based on filter
  const baseScore = filters.reduce((score, { acf_name, value }) => {
    const caseValue = extractAcfValue(acf[acf_name])

    // No score if not set
    if (caseValue === undefined || caseValue === null) return score

    // Do not score 'other/unknown' selections
    const normalized = String(value).toLowerCase()
    if (NO_SCORE_VALUES.includes(normalized)) return score

    return String(caseValue) === String(value)
      ? score + getMatchWeight(acf_name, value)
      : score
  }, 0)

  // And score based on hvac to relationship
  const relatedId = getRelatedSystemId(casePost)
  const relationScore =
    relatedId && matchingSystemIds.has(relatedId) ? RELATION_BONUS : 0

  return baseScore + relationScore
}
